"use client";

import { useState } from "react";

export type PaletteViewMode = "root" | "run-worker" | "kb-search";

/** What the palette is showing: the query, the highlighted row, and which screen. */
export function usePaletteView() {
  const [search, setSearch] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);

  // Sub-modal states for quick actions
  const [viewMode, setViewMode] = useState<PaletteViewMode>("root");
  const [kbQuery, setKbQuery] = useState("");

  /** Back to an empty root list, as on every open. */
  function reset() {
    setSearch("");
    setSelectedIndex(0);
    setViewMode("root");
    setKbQuery("");
  }

  return {
    search,
    setSearch,
    selectedIndex,
    setSelectedIndex,
    viewMode,
    setViewMode,
    kbQuery,
    setKbQuery,
    reset,
  };
}
